import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CalloutProps {
  children: ReactNode;
  title?: string;
  /** `caveat` marks the limits stated plainly rather than buried. */
  tone?: 'accent' | 'caveat';
  className?: string;
}

export function Callout({ children, title, tone = 'accent', className }: CalloutProps) {
  return (
    <div
      className={cn(
        'rounded-sm border-l-[3px] p-4 sm:p-5',
        tone === 'accent' && 'border-accent bg-accent-soft/60',
        tone === 'caveat' && 'border-line-strong bg-paper-2',
        className
      )}
    >
      {title && <p className={cn('label mb-1.5', tone === 'accent' ? 'text-accent-ink' : 'text-ink-3')}>{title}</p>}
      <div className="text-[13px] leading-relaxed text-ink-2 sm:text-sm">{children}</div>
    </div>
  );
}
